<template>
  <div class="container" id="content">
    <router-view />
  </div>
</template>
